module.exports = __webpack_public_path__ + "static/media/heating.36a7a093.svg";